const ColorResult = [
  { value: 3, label: "Green", Note: "Dưới cảnh báo" },
  { value: 1, label: "Blue", Note: "Dưới ngưỡng" },
  { value: 0, label: "Black", Note: "Bình thường" },
  { value: 2, label: "Red", Note: "Trên ngưỡng" },
  { value: 4, label: "Magenta", Note: "Trên cảnh báo" },
];

export {
    ColorResult
}